import { defineComponent } from "vue";
import { Container } from "aurelia-dependency-injection";
import { UserManager } from "oidc-client";
import { mapActions, mapState } from "pinia";
import { useApp } from "../../../pages-vue/App/useApp";

import eventBus from "../../../utilities/eventBus";
import { AnalyticsService } from "../../../services/analytics.service";
import AuthService from "../../../services/auth.service";
import { BranchesService } from "../../../services/branches-service";
import { ToastrService } from "../../../services/toastr.service";
import type { IBranchResponse } from "../../../interfaces/i-branch";
import { IGetuserDetailResponse, UserService } from "../../../services/user-service";
import { useLoadingIndicator } from "../../../pages-vue/Common/LoadingIndicator/store/useLoadingIndicator";

import DateTime from "../DateTime/DateTime.vue";
import WeatherReport from "../WeatherReport/WeatherReport.vue";

export default defineComponent({
    components: {
        DateTime,
        WeatherReport
    },

    props: {
        name: {
            type: String,
            default: ""
        },
        pageTitle: {
            type: String,
            default: ""
        },
        showBorder: {
            type: Boolean,
            default: false
        }
    },

    data() {
        return {
            _authService: null,
            _userService: null,
            _toastrService: null,
            _permissionManager: null,
            _analyticsService: null,
            _branchService: null,
            _logCategory: "Dashboard-Header",
            branches: [] as IBranchResponse[],
            _user: null,
            _userManager: null,
            userName: "",
            hasPlannertaskList: false,
            userbetaInfo: null as IGetuserDetailResponse
        };
    },

    created() {
        this._authService = Container.instance.get(AuthService);
        this._userService = Container.instance.get(UserService);
        this._analyticsService = Container.instance.get(AnalyticsService);
        this._branchService = Container.instance.get(BranchesService);
        this._userManager = Container.instance.get(UserManager);
        this._toastrService = Container.instance.get(ToastrService);
        eventBus.on("hasPlannertaskList", (response: boolean) => {
            this.hasPlannertaskList = response;
        });
    },

    computed: {
        ...mapState(useApp, ["organizations"]),
        hasBetaTogglePermission() {
            if (this.userbetaInfo?.Data) {
                return this.userbetaInfo.Data.IsBetaOpted && this.organizations?.length > 0;
            }
            return false;
        }
    },

    async mounted() {
        this.loadUser();
        this.showLoading(true);
        this.userbetaInfo = await this._userService.getUserDetails();
        this.showLoading(false);
    },

    methods: {
        ...mapActions(useLoadingIndicator, { showLoading: "SET_LOADING" }),
        logout(): void {
            this._authService.logout();
            this._analyticsService.logEvent({
                category: this._logCategory,
                action: "Log-Out",
                name: this.name
            });
        },

        goToHelp() {
            this.$router.push("/help");
        },

        async loadUser() {
            this._user = await this._userManager.getUser();
            if (this._user) {
                this.userName = this._user.profile.given_name;
            }
        }
    }
});
